import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const selectMpFields = async ({ categoryId, mpFields, selected = true }) => {
  const response = await axiosInstance.patch(
    `/mp_categories/${categoryId}/select_mp_fields/`,
    { mp_fields: mpFields, selected }
  );
  return response.data;
};

export const useSelectMpFields = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: selectMpFields,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mp-attributes'] });
    },
    retry: 0,
  });

  return {
    selectMpFields: mutation.mutate,
    selectMpFieldsAsync: mutation.mutateAsync,
    isSelecting: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    reset: mutation.reset,
  };
};
